import AddInsuranceInputs from './AddInsuranceInputs';
export default AddInsuranceInputs;
